import { gate } from 'hub-http/gates';
import { hasGate } from 'commerce-billing-lib/public/utilities';
export const useHasIndexActionsGate = () => hasGate(gate('Subscriptions:IndexActions'));
export const useHasExpandedMultiCurrencyGate = () => hasGate(gate('Commerce:ExpandedMulticurrency'));
export const useHasDeleteScopeGate = () => hasGate(gate('Permissions:CommerceSubscriptions'));